import cheader from '@/components/header/index.vue';

import elTableInfiniteScroll from 'el-table-infinite-scroll';
export default {
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll
  },
  name: 'order',
  data() {
    return {
      serverUrl: this.$store.state.config.serverUrl,
      isChecked: true,
      billType:"",
      order: {
        pay: {},
        endValue: '',
        createBy: {},
        updateBy: {},
        productList: []
      },
      search: {
        name: ''
      },
      isClick:false,
      disabled:false,
      loading: true,
      value:"",
      options: [{
        value: '',
        label: '全部'
      }, {
        value: '未报价',
        label: '未报价'
      }, {
        value: '已报价',
        label: '已报价'
      }],
      pageOption:[{
         value:100,
         label:"100"
      },{
        value:500,
        label:"500"
     },{
        value:1000,
        label:"1000"
    }],
      pageNo:0,
      pageSize:100,
      sizes:"14px",
      chooseLenth:0,
      createByid:"",
      total:0,
      subGoods: [],
      gysValue:"",
      gysOptions:[]
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    goodsFilter() {
      var _this = this
      return this.order.productList.filter((item) => {
        let tmpTicket = item.enquiryTicket ? item.enquiryTicket : '0'
        if(item.enquiryTicket!="" && item.enquiryTicket!=undefined){
          item.supProductList.forEach(function(res1,index){
            if (parseFloat(res1.ticket) > parseFloat(tmpTicket)) {
              res1.color = 'red'
            } else if (parseFloat(res1.ticket) < parseFloat(tmpTicket)) {
              res1.color = 'green'
            }
            if (parseFloat(res1.unticket) > parseFloat(tmpTicket)) {
              res1.color = 'red'
            } else if (parseFloat(res1.unticket) < parseFloat(tmpTicket)) {
              res1.color = 'green'
            }
            _this.$set(item.supProductList,index,res1)
          })
        }
        return item.product.name.indexOf(this.search.name) != -1
      })
    }
  },
  created() {
    //this.index()
  },
  components: {
    cheader
  },
  methods: {
    changeFont(type){
       if(type==0){
         this.sizes = "14px"
       }else{
         this.sizes = "16px"
       }
    },
    go(url) {
      this.$router.push(url)
    },
    load(){
      if(this.disabled==false){
        this.pageNo+=1
        this.index()
      }
    },
    changeIndex(){
      this.pageNo = 1
      this.subGoods = []
      this.index()
    },
    index() {
      this.loading = true
      this.disabled = true
      var _this = this
      var params = {
        id: this.$route.params.id,
        userId:  this.user.id,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        otherParam:"",
        orderBy: "",
        supplierId: this.gysValue
      }
      if(this.value!=""){
        params.quoteStatus = this.value
      }
      if(this.user.types==5){
        params.salesmanId = this.user.id
      }
      this.$http.get('/api/inquiry/viewOffer', {
        params: params
      }).then((res) => {
        this.loading = false
        this.total = res.data.total
        this.disabled = false
        this.billType = res.data.data.billType
        this.createByid = res.data.data.createByid
        var arr1 = []
        if(res.data.data.productList!=""){
          res.data.data.productList.forEach(function(item,index){
            if(res.data.data.isDak==true || res.data.data.isDak=='true'){
                if(item.supProductList[0].isNewRecord==false){
                  // 获取到value最小的那个值 如果是获取最大值 min 改成max
                  const minMathData =( Math.min.apply(Math,item.supProductList.map(item => { 
                    if(item.discountPrice!=undefined){
                      return parseFloat(item.discountPrice)
                    }
                    })));
                    
                  // 获取最小值信息
                  const minData = item.supProductList.find(item => minMathData === parseFloat(item.discountPrice))
                  item.radios = minData.supplier.id+","+minData.id+","+minData.productId
                  _this.$forceUpdate()
                  _this.$set(res.data.data.productList,index,item)
                  if(item.radios!=""){
                    if(item.radios==null){
                      item.radios=""
                    }
                    arr1.push(item.radios)
                  }
                }
                
            }else{
              if(item.supProductList[0].isNewRecord==false){
                // 获取到value最小的那个值 如果是获取最大值 min 改成max
                const minMathData =( Math.min.apply(Math,item.supProductList.map(item => { 
                  if(item.ticket!=undefined){
                    return parseFloat(item.ticket)
                  }else{
                    return parseFloat(item.unticket)
                  }
                  })));
                  
                // 获取最小值信息
                const minData = item.supProductList.find(item => minMathData === (item.ticket==undefined?parseFloat(item.unticket):parseFloat(item.ticket)))
                item.radios =minData.supplier.id+","+minData.id+","+minData.productId
                _this.$forceUpdate()
                _this.$set(res.data.data.productList,index,item)
                if(item.radios!=""){
                  if(item.radios==null){
                    item.radios=""
                  }
                  arr1.push(item.radios)
                }
              }
            }

          })
        }

        let supplierList = res.data.data.supplierList || [];
        console.log(supplierList)
        if(supplierList.length>0){
          this.gysOptions= supplierList.map(item => {
            return {
              value: item.supplier.user.id,
              label: item.supplier.name + " "+ item.supplier.company
            }
          })
        }else{
          this.gysOptions = []
        }

        if(arr1!=""){
          this.chooseLenth = arr1.length
        }else{
          this.chooseLenth = 0
        }
        res.data.data.supplierProductList ? '' : res.data.data.supplierProductList = []
        this.order = res.data.data
        switch (this.order.pay.value) {
          case 'cash':
            this.order.pay.value = '现金'
            break
          case 'card':
            this.order.pay.value = '银行卡'
            break
          case 'alipay':
            this.order.pay.value = '支付宝'
            break
          case 'wechat':
            this.order.pay.value = '微信'
            break
        }
      
        for (let item of this.order.productList) {
          // if (item.ticket < item.enquiryTicket) {
          //   console.log(typeof item.ticket)
          //   console.log(typeof item.ticket)
          // }
          item.available = item.available ? item.available : item.expected
          item.ticket = item.ticket ? item.ticket : '0'
          item.unticket = item.unticket ? item.unticket : '0'
          
          item.color = 'simple'
          if (!item.enquiryTicket) {
            continue
          }

          let tmpTicket = item.enquiryTicket ? item.enquiryTicket : '0'
          item.supProductList.forEach(function(res1,index){
            if (parseFloat(res1.ticket) > parseFloat(tmpTicket)) {
              res1.color = 'red'
            } else if (parseFloat(res1.ticket) < parseFloat(tmpTicket)) {
              res1.color = 'green'
            }
            if (parseFloat(res1.unticket) > parseFloat(tmpTicket)) {
              res1.color = 'red'
            } else if (parseFloat(res1.unticket) < parseFloat(tmpTicket)) {
              res1.color = 'green'
            }
            _this.$set(item.supProductList,index,res1)
          })
        }
        let arr = []
        if(this.order.productList!=""){
          this.subGoods = this.subGoods.concat(this.order.productList) //上拉加载新数据添加到数组中
        }
        this.subGoods.map((item,index) => {
          arr.push(item)
          if (arr.filter((itemer) => {
            return itemer.productId == item.productId
          }).length > 1) {
            return 'noid'
          } else {
            return item.id
          }
        })
        this.subGoods = new Set(this.subGoods)
        this.subGoods = [...this.subGoods]
       
        this.subGoods.forEach((item, index, arr) => {
          if (item == 'noid') {
            arr.splice(index, 1)
          } else if (!item) {
            arr.splice(index, 1)
          }
        })
        this.order.productList = this.subGoods
        if(res.data.data.productList=="" || res.data.data.productList.length < this.pageSize || this.subGoods.length == res.data.total) {
            this.disabled = true
        }
 
      })

    },
    changeValue(row,parent){
      parent.radios = row.supplier.id+','+row.id+','+row.productId
      this.$set(parent,"radios",row.supplier.id+','+row.id+','+row.productId)
      this.$forceUpdate() 
      var arr = []
      this.order.productList.forEach(function(res){
        if(res.radios!=""){
          if(res.radios==null){
           res.radios=""
          }
          arr.push(res.radios)
        }
      })
      if(arr!=""){
        this.chooseLenth = arr.length
      }else{
        this.chooseLenth = 0
      }
    },
    cancel(row){
      row.radios = ""
      this.$set(row,"radios","")
      this.$forceUpdate() 
      var arr = []
      this.order.productList.forEach(function(res){
        if(res.radios!=""){
          if(res.radios==null){
           res.radios=""
          }
          arr.push(res.radios)
        }
      })
      if(arr!=""){
        this.chooseLenth = arr.length
      }else{
        this.chooseLenth = 0
      }
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        let rows = this.order.productList.filter((item) => {
          return item.productId == row.productId
        })
        if (rows.indexOf(row) == 0) {
          return {
            rowspan: rows.length,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = `已选择 ${this.chooseLenth} 项`
          return
        } else {
          sums[index] = ''
          return
        }
      })
      return sums
    },
    submit() {
      if(this.isClick==true){
        return
      }
      this.isClick=true
      let arr = []
      this.order.productList.forEach(function(res){
         if(res.radios!=""){
           if(res.radios==null){
            res.radios=""
           }
           arr.push(res.radios)
         }
      })
      this.$http.post('/api/inquiry/saveEnquiry', {
        userId: this.user.id,
        inquiryId: this.$route.params.id,
        billType:this.billType,
        data: arr
      }).then((res) => {
        this.isClick=false
        if (res.data.success) {
          this.$router.push(`/order/result/${res.data.data}`)
        }else{
          this.$message.error(res.data.message)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/order/index/index.js